{
  "appId": "fidj-d204854971e704b9",
  "oidcIssuer": "https://api.fidj.ovh/oidc",
  "apiEndpoint": "https://api.fidj.ovh/v3",
  "dashboardUrl": "https://fidj.ovh",
  "title": "mlefree.com",
  "releaseVersion": "3.27.0",
  "localDemo": false,
  "allowAnonymous": false,
  "signin": "both",
  "welcome": "Welcome to mlefree.com",
  "description": "Projects, notes and experiments by Mat.",
  "content": "<p>Follow the projects I am building and the notes behind them.</p><p><a href='https://blog.mlefree.com/p/about.html'>About me</a> · <a href='https://github.com/ofidj'>Build with Fidj</a> · <a href='https://twitter.com/mat_cloud'>Follow on Twitter</a></p><p><a href='mailto:hello@mlefree.com'>Email hello@mlefree.com</a></p>",
  "highlights": [],
  "badges": [],
  "logo": "./brand/logo.gif",
  "favicon": "./brand/favicon.gif",
  "moduleEntry": "",
  "moduleVersion": "",
  "moduleLabel": "module",
  "moduleMount": null,
  "domain": "mlefree.com"
}
